import { Injectable } from '@angular/core';
import { DartfishFileConverter } from './Dartfish';
import { LongoFileConverter } from './LongoMatch/LongoFileConverter';
import { SportsCodeFileImporter } from './SportsCode/SportsCodeFileImporter';
import { IFileImporter } from './IFileConverter';

@Injectable()
export class DataConverter {
  public converters: string[] = [];

  constructor(
    private dartfishConverter: DartfishFileConverter,
    private longoMatchConverter: LongoFileConverter,
    private sportsCodeConverter: SportsCodeFileImporter
  ) {
    this.converters.push(dartfishConverter.name);
    this.converters.push(longoMatchConverter.name);
    this.converters.push(sportsCodeConverter.name);
  }

  getConverter(name: string): IFileImporter {
    switch (name) {
      case this.dartfishConverter.name: {
        return this.dartfishConverter;
      }
      case this.longoMatchConverter.name: {
        return this.longoMatchConverter;
      }
      case this.sportsCodeConverter.name: {
        return this.sportsCodeConverter;
      }
      default: {
        throw Error(`Converter with name ${name} not known.`);
      }
    }
  }
}
